import SelectAdapter from "select2/src/js/select2/data/select"
import Utils from "select2/src/js/select2/utils"

function DynDataAdapter($element, options) {
    this.queryCallback = options.get('queryCallback')
    DynDataAdapter.__super__.constructor.call(this, $element, options)
}

Utils.Extend(DynDataAdapter, SelectAdapter)

DynDataAdapter.prototype.query = function (params, callback) {
    callback({
        results: params.term ? this.queryCallback(params) : []
    })
}

DynDataAdapter.prototype.select = function (data) {
    var $option = this.$element.find('option').filter(function (i, elm) {
        return elm.value === data.id.toString();
    });

    if ($option.length === 0) {
        $option = this.option(data);

        this.addOptions($option);
    }

    DynDataAdapter.__super__.select.call(this, data);
};

export {DynDataAdapter as default}
